import {
  BOND_OF_INTEREST_ACTIONS,
  BOND_TRENDING_FLAG_ACTIONS,
  BOND_PRICE_CHARTS_ACTIONS,
  FEATURED_SEARCH_ACTIONS,
  BOND_FOLLOWEDBYUSER_ACTIONS,
  FILTER_LIST_DELETE_ACTIONS,
  BOND_RCENETPRICE_ACTIONS,
  MARK_AS_DEFAULT_GRAPH_ACTIONS,
  POSITION_BONDS_BY_USER_ACTIONS,
  POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS
} from "../../actionType/dashboard";

const intialState = {
  bondOfInterestList: [],
  isbondOfInterestListLoader: true,
  bondTrendingList: [],
  isbondTrendingListLoader: true,
  recentPriceList: [],
  isrecentPriceListLoader: true,
  bondPriceChartsData: [],
  isbondPriceChartsDataLoader: false,
  bondFollowedByUser: [],
  isBondFollowedByUserDataLoader: true,
  isBondsFollowedAndInPositionByUserLoader: true,
  BondsFollowedAndInPositionByUserData: [],
  positionBondsByUser: [],
  isPositionBoandsLoader: true,
  featuredSearchList: [],
  isfeaturedSearchListLoader: false,
  isMarkAsDefaultGraphLoader: false,
  markasDefaultGraphData: {},
  isfilterlisDeleteLoader: false,
  filterlisDeleteData: {},
};

export const dashboardReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    //  --------BOND_OF_INTEREST_ACTIONS---------------
    case BOND_OF_INTEREST_ACTIONS.GET_BOND_OF_INTEREST_REQUEST:
      return { ...state, isbondOfInterestListLoader: true };
    case BOND_OF_INTEREST_ACTIONS.GET_BOND_OF_INTEREST_RESPONSE:
      return { ...state, bondOfInterestList: payload, isbondOfInterestListLoader: false };
    case BOND_OF_INTEREST_ACTIONS.GET_BOND_OF_INTEREST_ERROR:
      return { ...state, bondOfInterestList: payload, isbondOfInterestListLoader: false };

    //   -------- BOND_TRENDING_FLAG_ACTIONS---------------
    case BOND_TRENDING_FLAG_ACTIONS.GET_TRENDING_FLAG_REQUEST:
      return { ...state, isbondTrendingListLoader: true };
    case BOND_TRENDING_FLAG_ACTIONS.GET_TRENDING_FLAG_RESPONSE:
      return { ...state, bondTrendingList: payload, isbondTrendingListLoader: false };
    case BOND_TRENDING_FLAG_ACTIONS.GET_TRENDING_FLAG_ERROR:
      return { ...state, bondTrendingList: payload, isbondTrendingListLoader: false };

    //   -------- BOND_RECENT_PRICE_ACTIONS---------------
    case BOND_RCENETPRICE_ACTIONS.GET_RCENETPRICE_REQUEST:
      return { ...state, isrecentPriceListLoader: true };
    case BOND_RCENETPRICE_ACTIONS.GET_RCENETPRICE_RESPONSE:
      return { ...state, recentPriceList: payload, isrecentPriceListLoader: false };
    case BOND_RCENETPRICE_ACTIONS.GET_RCENETPRICE_ERROR:
      return { ...state, recentPriceList: payload, isrecentPriceListLoader: false };

    //   -------- BOND_FOLLOWEDBYUSER_ACTIONS---------------
    case BOND_FOLLOWEDBYUSER_ACTIONS.GET_FOLLOWEDBYUSER_REQUEST:
      return { ...state, isBondFollowedByUserDataLoader: true };
    case BOND_FOLLOWEDBYUSER_ACTIONS.GET_FOLLOWEDBYUSER_RESPONSE:
      return { ...state, bondFollowedByUser: payload, isBondFollowedByUserDataLoader: false };
    case BOND_FOLLOWEDBYUSER_ACTIONS.GET_FOLLOWEDBYUSER_ERROR:
      return { ...state, bondFollowedByUser: payload, isBondFollowedByUserDataLoader: false };

    //   -------- POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS---------------
    case POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS.POSITION_AND_FOLLOWED_BOND_BY_USER_REQUEST:
      return { ...state, isBondsFollowedAndInPositionByUserLoader: true };
    case POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS.POSITION_AND_FOLLOWED_BOND_BY_USER_RESPONSE:
      return { ...state, BondsFollowedAndInPositionByUserData: payload, isBondsFollowedAndInPositionByUserLoader: false };
    case POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS.POSITION_AND_FOLLOWED_BOND_BY_USER_ERROR:
      return { ...state, BondsFollowedAndInPositionByUserData: payload, isBondsFollowedAndInPositionByUserLoader: false };

    //   -------- POSITION_BONDS_BY_USER_ACTIONS---------------
    case POSITION_BONDS_BY_USER_ACTIONS.POSITION_BONDS_BY_USER_REQUEST:
      return { ...state, isPositionBoandsLoader: true };
    case POSITION_BONDS_BY_USER_ACTIONS.POSITION_BONDS_BY_USER_RESPONSE:
      return { ...state, positionBondsByUser: payload, isPositionBoandsLoader: false };
    case POSITION_BONDS_BY_USER_ACTIONS.POSITION_BONDS_BY_USER_ERROR:
      return { ...state, positionBondsByUser: payload, isPositionBoandsLoader: false };

    //   -------- BOND_PRICE_CHARTS_ACTIONS---------------
    case BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_REQUEST:
      return { ...state, isbondPriceChartsDataLoader: true };
    case BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_RESPONSE:
      return { ...state, bondPriceChartsData: payload, isbondPriceChartsDataLoader: false };
    case BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_ERROR:
      return { ...state, bondPriceChartsData: payload, isbondPriceChartsDataLoader: false };

    //   -------- FEATURED_SEARCH_ACTIONS---------------
    case FEATURED_SEARCH_ACTIONS.GET_FEATURED_SEARCH_REQUEST:
      return { ...state, isfeaturedSearchListLoader: true };
    case FEATURED_SEARCH_ACTIONS.GET_FEATURED_SEARCH_RESPONSE:
      return { ...state, featuredSearchList: payload, isfeaturedSearchListLoader: false };
    case FEATURED_SEARCH_ACTIONS.GET_FEATURED_SEARCH_ERROR:
      return { ...state, featuredSearchList: payload, isfeaturedSearchListLoader: false };

    //   --------MARK_AS_DEFAULT_GRAPH_ACTIONS---------------
    case MARK_AS_DEFAULT_GRAPH_ACTIONS.GET_MARK_AS_DEFAULT_GRAPH_REQUEST:
      return { ...state, isMarkAsDefaultGraphLoader: true };
    case MARK_AS_DEFAULT_GRAPH_ACTIONS.GET_MARK_AS_DEFAULT_GRAPH_RESPONSE:
      return { ...state, markasDefaultGraphData: payload, isMarkAsDefaultGraphLoader: false };
    case MARK_AS_DEFAULT_GRAPH_ACTIONS.GET_MARK_AS_DEFAULT_GRAPH_ERROR:
      return { ...state, markasDefaultGraphData: payload, isMarkAsDefaultGraphLoader: false };

    //  --------PORTFOLIOS_DELETE_ACTIONS---------------
    case FILTER_LIST_DELETE_ACTIONS.FILTER_LIST_DELETE_REQUEST:
      return { ...state, isfilterlisDeleteLoader: true };
    case FILTER_LIST_DELETE_ACTIONS.FILTER_LIST_DELETE_REQUEST:
      return { ...state, filterlisDeleteData: payload, isfilterlisDeleteLoader: false, };
    case FILTER_LIST_DELETE_ACTIONS.FILTER_LIST_DELETE_ERROR:
      return { ...state, filterlisDeleteData: payload, isfilterlisDeleteLoader: false, };

    default:
      return state;
  }
};
